export default "__VITE_ASSET__DvtGSd6b__"